import { useEffect, useState, useCallback } from 'react';
import api from '../api/axios';

const useMaterialOptions = (enabled = true) => {
  const [materialTypes,     setMaterialTypes]     = useState([]);
  const [plants,            setPlants]            = useState([]);
  const [materialGroups,    setMaterialGroups]    = useState([]);
  const [materialGroups1,   setMaterialGroups1]   = useState([]);
  const [materialGroups2,   setMaterialGroups2]   = useState([]);
  const [materialGroups3,   setMaterialGroups3]   = useState([]);
  const [materialGroups4,   setMaterialGroups4]   = useState([]);
  const [materialGroups5,   setMaterialGroups5]   = useState([]);
  const [controlCodes,      setControlCodes]      = useState([]);
  const [uoms,              setUoms]              = useState([]);
  const [mrpTypes,          setMrpTypes]          = useState([]);
  const [valuationTypes,    setValuationTypes]    = useState([]);
  const [lotSizes,          setLotSizes]          = useState([]);
  const [inspectionTypes,   setInspectionTypes]   = useState([]);
  const [salesOrgs,         setSalesOrgs]         = useState([]);
  const [storageLocations,  setStorageLocations]  = useState([]);
  const [profitCenters,     setProfitCenters]     = useState([]);
  const [distributionChannels, setDistributionChannels] = useState([]);
  const [divisions,         setDivisions]         = useState([]);

  useEffect(() => {
    if (!enabled) return;
    api.get('/sap/options/material-types').then(r => setMaterialTypes(r.data)).catch(() => {});
    api.get('/sap/options/plants').then(r => setPlants(r.data)).catch(() => {});
    api.get('/sap/options/sales-organizations').then(r => setSalesOrgs(r.data)).catch(() => {});
    api.get('/sap/options/material-group').then(r => setMaterialGroups(r.data)).catch(() => {});
    api.get('/sap/options/material-groups-1').then(r => setMaterialGroups1(r.data)).catch(() => {});
    api.get('/sap/options/material-groups-2').then(r => setMaterialGroups2(r.data)).catch(() => {});
    api.get('/sap/options/material-groups-3').then(r => setMaterialGroups3(r.data)).catch(() => {});
    api.get('/sap/options/material-groups-4').then(r => setMaterialGroups4(r.data)).catch(() => {});
    api.get('/sap/options/material-groups-5').then(r => setMaterialGroups5(r.data)).catch(() => {});
    api.get('/sap/options/control-codes').then(r => setControlCodes(r.data)).catch(() => {});
    api.get('/sap/options/uom').then(r => setUoms(r.data)).catch(() => {});
    api.get('/sap/options/mrp-types').then(r => setMrpTypes(r.data)).catch(() => {});
    api.get('/sap/options/valuation-types').then(r => setValuationTypes(r.data)).catch(() => {});
    api.get('/sap/options/lot-sizes').then(r => setLotSizes(r.data)).catch(() => {});
    api.get('/sap/options/inspection-types').then(r => setInspectionTypes(r.data)).catch(() => {});
  }, [enabled]);

  const refetchPlantDependents = useCallback((plant) => {
    if (!plant) { setStorageLocations([]); setProfitCenters([]); return; }
    api.get('/sap/options/storage-locations', { params: { plant } }).then(r => setStorageLocations(r.data)).catch(() => {});
    api.get('/sap/options/profit-centers', { params: { plant } }).then(r => setProfitCenters(r.data)).catch(() => {});
  }, []);

  const refetchSalesAreaDependents = useCallback((salesOrg) => {
    if (!salesOrg) { setDistributionChannels([]); setDivisions([]); return; }
    api.get('/sap/options/sales-area-config', { params: { salesOrg } })
      .then(r => { setDistributionChannels(r.data.distribution_channels); setDivisions(r.data.divisions); })
      .catch(() => {});
  }, []);

  return {
    materialTypes, plants, salesOrgs,
    materialGroups, materialGroups1, materialGroups2, materialGroups3, materialGroups4, materialGroups5,
    controlCodes, uoms, mrpTypes, valuationTypes, lotSizes, inspectionTypes,
    storageLocations, profitCenters, distributionChannels, divisions,
    refetchPlantDependents, refetchSalesAreaDependents,
  };
};

export default useMaterialOptions;
